<template>
    <el-form
        ref="ruleFormRef"
        class="insured-dialog-form catalog-person-form"
        :class="{
            'catalog-person-form--split': isCatalogAgentRequest(),
            'catalog-person-form--errors-border-only': isCatalogAgentRequest(),
        }"
        label-position="top"
        :rules="formRules"
        :model="values"
        @submit.prevent
    >
        <div class="catalog-person-form__layout">
                    <div class="catalog-person-form__col">
                        <h3 class="catalog-person-form__title">{{ $t('identity_card') || 'Şəxsiyyət vəsiqəsi' }}</h3>
                        <div class="catalog-person-form__id-block">
                            <template v-if="isCatalogAgentRequest()">
                                <div class="catalog-person-form__id-row">
                                    <el-form-item
                                        class="catalog-person-form__pin-item catalog-person-form__pin-item--data"
                                        :label="$t('pinCode') || 'PİN Kod'"
                                        :prop="isCatalogAgentRequest() ? 'pin' : undefined"
                                    >
                                        <el-input
                                            v-model="values.pin"
                                            maxlength="7"
                                            :disabled="isIdentityFieldsLocked"
                                        />
                                    </el-form-item>
                                    <el-form-item
                                        class="catalog-person-form__doc-item catalog-person-form__doc-item--data"
                                        :label="$t('catalogDocSeriesNumber')"
                                    >
                                        <div
                                            class="catalog-person-form__doc-combo"
                                            :class="{ 'catalog-person-form__doc-combo--disabled': isIdentityFieldsLocked }"
                                        >
                                            <el-form-item prop="docSeries" label-width="0" class="catalog-person-form__doc-field">
                                                <el-input
                                                    v-model="values.docSeries"
                                                    maxlength="3"
                                                    class="catalog-person-form__doc-series"
                                                    :placeholder="$t('series')"
                                                    :disabled="isIdentityFieldsLocked"
                                                />
                                            </el-form-item>
                                            <span class="catalog-person-form__doc-divider" aria-hidden="true" />
                                            <el-form-item prop="docNumber" label-width="0" class="catalog-person-form__doc-field">
                                                <el-input
                                                    v-model="values.docNumber"
                                                    class="catalog-person-form__doc-number"
                                                    :placeholder="$t('number')"
                                                    :disabled="isIdentityFieldsLocked"
                                                />
                                            </el-form-item>
                                        </div>
                                    </el-form-item>
                                </div>
                            </template>
                            <template v-else>
                                <div class="catalog-person-form__pin-toolbar">
                                    <el-form-item
                                        class="catalog-person-form__pin-item"
                                        :label="$t('pinCode') || 'PİN Kod'"
                                    >
                                        <el-input
                                            v-model="values.pin"
                                            maxlength="7"
                                            class="catalog-person-form__pin-input"
                                        >
                                            <template #append>
                                                <el-button
                                                    class="catalog-person-form__asan-btn"
                                                    type="primary"
                                                    native-type="button"
                                                    :loading="formPersonSearchLoading"
                                                    :disabled="formPersonSearchLoading"
                                                    @click.prevent="searchPersonByPin()"
                                                >
                                                    ASAN
                                                </el-button>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <el-form-item
                                    class="catalog-person-form__doc-item"
                                    :label="$t('catalogDocSeriesNumber')"
                                >
                                    <div class="catalog-person-form__doc-combo">
                                        <el-form-item prop="docSeries" label-width="0" class="catalog-person-form__doc-field">
                                            <el-input
                                                v-model="values.docSeries"
                                                maxlength="3"
                                                class="catalog-person-form__doc-series"
                                                :placeholder="$t('series')"
                                            />
                                        </el-form-item>
                                        <span class="catalog-person-form__doc-divider" aria-hidden="true" />
                                        <el-form-item prop="docNumber" label-width="0" class="catalog-person-form__doc-field">
                                            <el-input
                                                v-model="values.docNumber"
                                                class="catalog-person-form__doc-number"
                                                :placeholder="$t('number')"
                                            />
                                        </el-form-item>
                                    </div>
                                </el-form-item>
                            </template>
                        </div>

                <h3 class="catalog-person-form__title">{{ $t('general_info') || 'Ümumi məlumat' }}</h3>
                <div class="catalog-person-form__row catalog-person-form__row--3">
                    <el-form-item
                        :label="$t('lastName') || 'Soyadı'"
                        :prop="isCatalogAgentRequest() ? 'lastName' : undefined"
                    >
                        <el-input v-model="values.lastName" :disabled="isIdentityFieldsLocked" />
                    </el-form-item>
                    <el-form-item
                        :label="$t('firstName') || 'Adı'"
                        prop="firstName"
                    >
                        <el-input v-model="values.firstName" :disabled="isIdentityFieldsLocked" />
                    </el-form-item>
                    <el-form-item
                        :label="$t('middleName') || 'Atasının adı'"
                        :prop="isCatalogAgentRequest() ? 'middleName' : undefined"
                    >
                        <el-input v-model="values.middleName" :disabled="isIdentityFieldsLocked" />
                    </el-form-item>
                </div>
                <div class="catalog-person-form__row catalog-person-form__row--2">
                    <el-form-item :label="$t('sex') || 'Cinsi'">
                        <el-select v-model="values.sex" :disabled="isIdentityFieldsLocked">
                            <el-option :label="$t('male') || 'Kişi'" value="m" />
                            <el-option :label="$t('female') || 'Qadın'" value="f" />
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        :label="$t('birthDateAge') || 'Doğum tarixi'"
                        :prop="isCatalogAgentRequest() ? undefined : 'dateOfBirth'"
                    >
                        <el-date-picker
                            v-model="values.dateOfBirth"
                            format="DD.MM.YYYY"
                            type="date"
                            :placeholder="$t('pickDate')"
                            style="width: 100%"
                            :disabled="isIdentityFieldsLocked"
                            :disabled-date="(date) => date > new Date() || date < new Date('1900-01-01')"
                        />
                    </el-form-item>
                </div>
            </div>

            <div class="catalog-person-form__col catalog-person-form__col--right">
                <h3 class="catalog-person-form__title">{{ $t('address') || 'Ünvan' }}</h3>
                <el-form-item class="catalog-person-form__address-line" :label="$t('address') || 'Ünvan'" prop="address">
                    <el-input
                        v-model="values.address"
                        :disabled="isAddressFieldsLocked"
                    />
                </el-form-item>
                <el-form-item
                    class="catalog-person-form__zip-item"
                    :label="$t('postalCode') || 'Poçt indeksi'"
                >
                    <el-input v-model="values.zip" maxlength="10" :disabled="isAddressFieldsLocked" />
                </el-form-item>

                <h3 class="catalog-person-form__title catalog-person-form__title--gap">{{ $t('contactLabel') || 'Əlaqə' }}</h3>
                <div class="catalog-person-form__row catalog-person-form__row--2">
                    <el-form-item
                        :label="$t('mobilePhone') || 'Mobil telefon'"
                        :prop="isCatalogAgentRequest() ? 'mobilePhone' : undefined"
                    >
                        <CatalogMobilePhoneInput
                            v-if="isCatalogAgentRequest()"
                            v-model="values.mobilePhone"
                        />
                        <el-input v-else v-model="values.mobilePhone" />
                    </el-form-item>
                    <el-form-item :label="$t('emailLabel') || 'Email'" prop="email">
                        <el-input v-model="values.email" />
                    </el-form-item>
                </div>
            </div>
        </div>

        <section v-if="isCatalogAgentRequest()" class="catalog-person-queue">
            <div class="catalog-person-queue__toolbar">
                <h3 class="catalog-person-form__title catalog-person-queue__heading">
                    {{ $t('catalogInsuredQueueTitle') }}
                    <span v-if="displayInsuredRows.length" class="catalog-person-queue__count">
                        {{ displayInsuredRows.length }}
                    </span>
                </h3>
                <div class="catalog-person-queue__toolbar-actions">
                    <label
                        v-if="canShowIncludeMainCheckbox"
                        class="catalog-person-queue__include-main"
                    >
                        <el-checkbox
                            v-model="includeMainInInsuredList"
                            :disabled="!canIncludeMainInList"
                        />
                        <span>{{ $t('catalogMainAlsoInsured') }}</span>
                    </label>
                    <button
                        v-if="editingQueuePersonId"
                        type="button"
                        class="insured-dialog-btn insured-dialog-btn--muted catalog-person-queue__open-btn"
                        @click="cancelQueuePersonEdit"
                    >
                        {{ $t('catalogInsuredQueueCancelEdit') }}
                    </button>
                    <button
                        v-if="editingQueuePersonId"
                        type="button"
                        class="insured-dialog-btn insured-dialog-btn--primary catalog-person-queue__open-btn"
                        :disabled="!canSaveQueueEdit"
                        @click="saveQueuePersonEdit"
                    >
                        {{ $t('catalogInsuredQueueSave') }}
                    </button>
                    <button
                        v-else
                        type="button"
                        class="insured-dialog-btn insured-dialog-btn--primary catalog-person-queue__open-btn"
                        :disabled="!canAddCurrentPerson"
                        @click="addCurrentPersonToQueue"
                    >
                        {{ $t('catalogInsuredQueueAdd') }}
                    </button>
                </div>
            </div>

            <p v-if="editingQueuePersonId" class="catalog-person-queue__edit-hint">
                {{ $t('catalogInsuredQueueEditHint') }}
            </p>

            <div v-if="displayInsuredRows.length" class="catalog-person-queue__table-wrap">
                <table class="catalog-person-queue__table">
                    <thead>
                        <tr>
                            <th class="catalog-person-queue__main-col">{{ $t('catalogMainInsured') }}</th>
                            <th>{{ $t('pinCode') }}</th>
                            <th>{{ $t('fullNameLabel') }}</th>
                            <th>{{ $t('sex') }}</th>
                            <th>{{ $t('birthDateAge') }}</th>
                            <th>{{ $t('mobilePhone') }}</th>
                            <th class="catalog-person-queue__actions-col" aria-hidden="true"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="person in displayInsuredRows"
                            :key="person.id"
                            :class="{
                                'catalog-person-queue__row--main': person.isTableMain,
                                'catalog-person-queue__row--editing': person.id === editingQueuePersonId,
                            }"
                        >
                            <td class="catalog-person-queue__main-col">
                                <button
                                    v-if="!person.isVirtual"
                                    type="button"
                                    class="catalog-person-queue__main-toggle"
                                    :class="{ 'is-active': person.isTableMain }"
                                    :aria-pressed="person.isTableMain"
                                    :title="$t('catalogMainInsuredPick')"
                                    @click="setMainFromQueue(person.id)"
                                >
                                    <span v-if="person.isTableMain" class="catalog-person-queue__main-toggle-icon" aria-hidden="true">✓</span>
                                    {{ $t('catalogMainInsured') }}
                                </button>
                            </td>
                            <td>{{ person.pin || '—' }}</td>
                            <td>{{ person.fullName }}</td>
                            <td>{{ person.sexLabel }}</td>
                            <td>{{ person.birthDateLabel }}</td>
                            <td>{{ person.values?.mobilePhone || '—' }}</td>
                            <td class="catalog-person-queue__actions-col">
                                <div class="catalog-person-queue__actions">
                                    <button
                                        type="button"
                                        class="catalog-person-queue__edit"
                                        :title="$t('catalogInsuredQueueEdit')"
                                        :aria-label="$t('catalogInsuredQueueEdit')"
                                        @click="startEditInsuredRow(person)"
                                    >
                                        <svg
                                            class="catalog-person-queue__edit-icon"
                                            viewBox="0 0 24 24"
                                            aria-hidden="true"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1.003 1.003 0 0 0 0-1.42l-2.34-2.34a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z"
                                            />
                                        </svg>
                                    </button>
                                    <button
                                        v-if="!person.isVirtual"
                                        type="button"
                                        class="catalog-person-queue__remove"
                                        :title="$t('catalogInsuredQueueRemove')"
                                        @click="removeInsuredRow(person)"
                                    >
                                        ×
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p v-else class="catalog-person-queue__empty">{{ $t('catalogInsuredQueueEmpty') }}</p>
        </section>

        <div class="insured-dialog-footer">
            <button type="button" class="insured-dialog-btn insured-dialog-btn--muted" :disabled="submitting" @click="HandleCancel">
                {{ $t('btnCancel') }}
            </button>
            <button
                type="button"
                class="insured-dialog-btn insured-dialog-btn--primary"
                :disabled="submitting || !canSubmitCatalog"
                @click="SubmitForm"
            >
                <i v-if="submitting" class="fa fa-spinner fa-spin" aria-hidden="true" />
                {{ submitting ? $t('catalogInsertCreating') : catalogSubmitLabel }}
            </button>
        </div>
    </el-form>
</template>

<script>
import Source from "@/project/Source/client";
import Core from "@/project/Source/core";
import Utils from "@/project/Source/utils";
import MedicalAgent from "../../Source/medicalAgent";
import {
    buildAgentRequestInsertPayload,
    parseAgentRequestInsertResult,
    normalizePin,
} from "../../Catalog/catalogAgentRequest.js";
import {
    buildPersonInfoRequest,
    extractPersonInfoErrorMessage,
    extractPersonInfoRow,
    isPersonInfoFound,
    mapPersonInfoToForm,
    omitTestIdDocFromMapped,
    validatePersonInfoSearchInput,
    CATALOG_PERSON_SEARCH_MODE,
} from "../../Catalog/catalogPersonSearch.js";
import { isAzerbaijanMobilePhone } from "../../Catalog/catalogPhone.js";
import CatalogMobilePhoneInput from "../../Catalog/CatalogMobilePhoneInput.vue";
import {
    findQueuedPersonIndex,
    upsertQueuedPerson,
    updateQueuedPerson,
    findQueuedPersonPinConflict,
    removeQueuedPerson,
    isQueuedPersonValid,
    formatQueuedPersonName,
    formatQueuedPersonBirthDate,
    createQueuedPerson,
    createFormMainInsured,
    resolveMainInsuredIdAfterRemove,
} from "../../Catalog/catalogInsuredQueue.js";

function emptyEntryFormValues(townId = null) {
    return { sex: "m", ...(townId != null ? { townId } : {}) };
}

function emptySearchDraft() {
    return { pin: "", docSeries: "", docNumber: "" };
}

export default {
    name: "CatalogPersonEditDialog",
    components: { CatalogMobilePhoneInput },
    emits: ["close-dialog", "insert-dialog", "search-loading", "reset-search-draft"],
    props: {
        object: Object,
        editing: Boolean,
        insert: Boolean,
        noRedirect: { type: Boolean, default: false },
        catalogProductId: { type: [Number, String], default: null },
        catalogProduct: { type: Object, default: null },
        catalogSearchDraft: { type: Object, default: null },
    },
    data() {
        return {
            submitting: false,
            formPersonSearchLoading: false,
            searchedPin: null,
            personSearchDone: false,
            pinQueue: [],
            mainInsuredSource: "form",
            mainInsuredId: null,
            includeMainInInsuredList: false,
            mainInsuredSnapshot: null,
            editingQueuePersonId: null,
            editingQueueIsAsan: false,
            searchDraft: emptySearchDraft(),
            values: {
                sex: 'm'
            },
            towns: [],
        }
    },
    computed: {
        formRules() {
            const required = {
                required: true,
                message: this.isCatalogAgentRequest()
                    ? ' '
                    : (this.$t('formRequired') || 'Mütləq sahə'),
                trigger: 'change',
            };
            const emailFormatRule = {
                type: 'email',
                message: this.$t('invalidEmail') || 'Email formatı düzgün deyil',
                trigger: ['blur', 'change'],
            };

            if (!this.isCatalogAgentRequest()) {
                return {
                    firstName: [required],
                    dateOfBirth: [required],
                    email: [emailFormatRule],
                };
            }

            // Manual entries: PIN / series / number optional.
            const isManualEntry = this.editingQueuePersonId
                ? !this.editingQueueIsAsan
                : this.isCatalogManualMode();
            const identityRules = isManualEntry ? {} : {
                pin: [required],
                docSeries: [required],
                docNumber: [required],
            };

            return {
                ...identityRules,
                address: [required],
                lastName: [required],
                firstName: [required],
                middleName: [required],
                mobilePhone: [
                    {
                        validator: (_rule, value, callback) => {
                            const trimmed = value != null ? String(value).trim() : "";
                            if (!trimmed || !isAzerbaijanMobilePhone(trimmed)) {
                                callback(new Error(' '));
                                return;
                            }
                            callback();
                        },
                        trigger: ['blur', 'change'],
                    },
                ],
                email: [required, emailFormatRule],
            };
        },
        canSubmitCatalog() {
            if (!this.isCatalogAgentRequest()) return true;
            if (this.mainInsuredSource === "queue") {
                const main = this.pinQueue.find((person) => person.id === this.mainInsuredId);
                return Boolean(main && isQueuedPersonValid(main.values));
            }
            return Boolean(
                this.mainInsuredSnapshot && isQueuedPersonValid(this.mainInsuredSnapshot.values)
            );
        },
        canIncludeMainInList() {
            return this.canShowIncludeMainCheckbox;
        },
        canShowIncludeMainCheckbox() {
            if (!this.isCatalogAgentRequest()) return false;
            if (this.mainInsuredSource === "queue" && this.mainInsuredId) {
                const main = this.pinQueue.find((person) => person.id === this.mainInsuredId);
                return Boolean(main && isQueuedPersonValid(main.values));
            }
            return Boolean(
                this.mainInsuredSnapshot && isQueuedPersonValid(this.mainInsuredSnapshot.values)
            );
        },
        canAddCurrentPerson() {
            if (!this.isCatalogAgentRequest()) return false;
            if (this.editingQueuePersonId) return false;
            if (!isQueuedPersonValid(this.values)) return false;
            if (this.isCatalogManualMode()) return true;
            return Boolean(this.personSearchDone && this.searchedPin);
        },
        canSaveQueueEdit() {
            if (!this.editingQueuePersonId) return false;
            if (!isQueuedPersonValid(this.values)) return false;
            if (this.editingQueueIsAsan) return true;
            if (this.isCatalogManualMode()) return true;
            return Boolean(this.personSearchDone && this.searchedPin);
        },
        displayInsuredRows() {
            const formMainPin = normalizePin(this.mainInsuredSnapshot?.values?.pin);
            const rows = this.pinQueue.map((person) => {
                const pin = normalizePin(person.pin);
                return {
                    id: person.id,
                    pin,
                    values: person.values,
                    fullName: formatQueuedPersonName(person.values),
                    sexLabel: this.formatQueuedSexLabel(person.values),
                    birthDateLabel: formatQueuedPersonBirthDate(person.values?.dateOfBirth),
                    isTableMain: this.mainInsuredSource === "queue" && person.id === this.mainInsuredId,
                    isVirtual: false,
                };
            });

            if (
                this.mainInsuredSource === "form" &&
                this.includeMainInInsuredList &&
                this.mainInsuredSnapshot?.values &&
                !rows.some((row) => row.pin === formMainPin)
            ) {
                rows.unshift({
                    id: "__main-insured__",
                    pin: formMainPin,
                    values: this.mainInsuredSnapshot.values,
                    fullName: formatQueuedPersonName(this.mainInsuredSnapshot.values),
                    sexLabel: this.formatQueuedSexLabel(this.mainInsuredSnapshot.values),
                    birthDateLabel: formatQueuedPersonBirthDate(this.mainInsuredSnapshot.values?.dateOfBirth),
                    isTableMain: false,
                    isVirtual: true,
                });
            }

            return rows;
        },
        catalogSubmitLabel() {
            if (!this.isCatalogAgentRequest()) {
                return !this.editing ? this.$t("btnInsert") : this.$t("accept");
            }
            return this.$t("btnInsert");
        },
        activeSearchDraft() {
            if (this.isCatalogAgentRequest() && this.catalogSearchDraft) {
                return this.catalogSearchDraft;
            }
            return this.searchDraft;
        },
        isIdentityFieldsLocked() {
            if (!this.isCatalogAgentRequest()) return false;
            if (this.editingQueuePersonId && !this.editingQueueIsAsan) return false;
            return !this.isCatalogManualMode();
        },
        isAddressFieldsLocked() {
            if (!this.isCatalogAgentRequest()) return false;
            if (this.editingQueuePersonId) return false;
            return !this.isCatalogManualMode();
        },
    },
    watch: {
        formPersonSearchLoading(loading) {
            if (this.isCatalogAgentRequest()) {
                this.$emit("search-loading", loading);
            }
        },
        "catalogSearchDraft.searchMode"() {
            if (!this.isCatalogAgentRequest()) return;
            this.personSearchDone = false;
            this.searchedPin = null;
            this.includeMainInInsuredList = false;
            this.mainInsuredSnapshot = null;
            this.mainInsuredSource = "form";
            this.mainInsuredId = null;
        },
        "values.pin"(next) {
            if (!this.isCatalogAgentRequest()) return;
            if (this.isCatalogManualMode()) return;
            if (!this.personSearchDone) return;
            if (normalizePin(next) !== normalizePin(this.searchedPin)) {
                this.personSearchDone = false;
                this.searchedPin = null;
                this.includeMainInInsuredList = false;
                this.mainInsuredSnapshot = null;
                this.mainInsuredSource = "form";
                this.mainInsuredId = null;
            }
        },
        "values.dateOfBirth"() {
            if (!this.isCatalogAgentRequest()) return;
            this.$nextTick(() => {
                this.$refs.ruleFormRef?.validateField?.('mobilePhone')?.catch?.(() => {});
            });
        },
        canIncludeMainInList(enabled) {
            if (!enabled && this.includeMainInInsuredList) {
                this.includeMainInInsuredList = false;
            }
        },
    },
    beforeMount() {
        if (this.editing == true && this.object) {
            this.values = { ...this.object };
        } else if (!this.values.sex) {
            this.values.sex = 'm';
        }
        this.LoadTowns();
    },
    methods: {
        formatQueuedSexLabel(values) {
            if (values?.sex === "m") return this.$t("male") || "Kişi";
            if (values?.sex === "f") return this.$t("female") || "Qadın";
            return "—";
        },
        canUseFormAsMain() {
            if (!this.isCatalogAgentRequest()) return false;
            if (!isQueuedPersonValid(this.values)) return false;
            if (this.isCatalogManualMode()) return true;
            return Boolean(this.personSearchDone && this.searchedPin);
        },
        resolveCurrentPersonIsAsan() {
            return !this.isCatalogManualMode() && Boolean(this.personSearchDone);
        },
        syncMainInsuredSnapshot() {
            if (!this.canUseFormAsMain()) return;
            const pin = normalizePin(this.searchedPin || this.values.pin);
            this.mainInsuredSnapshot = createFormMainInsured(
                this.values,
                pin,
                this.resolveCurrentPersonIsAsan()
            );
            this.mainInsuredSource = "form";
            this.mainInsuredId = null;
        },
        setMainFromQueue(id) {
            if (!id) return;
            this.mainInsuredSource = "queue";
            this.mainInsuredId = id;
        },
        startEditInsuredRow(person) {
            if (!person?.id) return;

            if (person.id === "__main-insured__") {
                if (!this.mainInsuredSnapshot?.values) return;
                this.editingQueuePersonId = "__main-insured__";
                this.editingQueueIsAsan = this.mainInsuredSnapshot.isAsan === true;
                this.values = { ...this.mainInsuredSnapshot.values };
                this.searchedPin =
                    this.mainInsuredSnapshot.searchedPin ||
                    normalizePin(this.mainInsuredSnapshot.values?.pin);
                this.personSearchDone = this.editingQueueIsAsan;
                this.$nextTick(() => this.$refs.ruleFormRef?.clearValidate?.());
                return;
            }

            const entry = this.pinQueue.find((queued) => queued.id === person.id);
            if (!entry) return;

            this.editingQueuePersonId = person.id;
            this.editingQueueIsAsan = entry.isAsan === true;
            this.values = { ...entry.values };
            this.searchedPin = entry.searchedPin || entry.pin;
            this.personSearchDone = this.editingQueueIsAsan || this.isCatalogManualMode();
            this.$nextTick(() => {
                this.$refs.ruleFormRef?.clearValidate?.();
                this.$el
                    ?.querySelector?.(".catalog-person-form__layout")
                    ?.scrollIntoView?.({ behavior: "smooth", block: "start" });
            });
        },
        cancelQueuePersonEdit() {
            this.resetEntryForm();
        },
        saveQueuePersonEdit() {
            if (!this.isCatalogAgentRequest() || !this.editingQueuePersonId) return;

            this.$refs.ruleFormRef.validate((valid) => {
                if (!valid) return;
                if (!isQueuedPersonValid(this.values)) {
                    Utils.Alert(this.$t("catalogInsuredQueueInvalid"));
                    return;
                }

                const pin = normalizePin(
                    this.editingQueueIsAsan
                        ? this.searchedPin || this.values.pin
                        : this.values.pin || this.searchedPin
                );
                const payload = { ...this.values, pin };
                const isAsan = this.editingQueueIsAsan;

                if (this.editingQueuePersonId === "__main-insured__") {
                    this.mainInsuredSnapshot = createFormMainInsured(payload, pin, isAsan);
                    this.cancelQueuePersonEdit();
                    return;
                }

                const conflict = findQueuedPersonPinConflict(
                    this.pinQueue,
                    pin,
                    this.editingQueuePersonId
                );
                if (conflict) {
                    Utils.Alert(this.$t("catalogInsuredQueuePinConflict"));
                    return;
                }

                this.pinQueue = updateQueuedPerson(
                    this.pinQueue,
                    this.editingQueuePersonId,
                    payload,
                    pin,
                    isAsan
                );
                this.cancelQueuePersonEdit();
            });
        },
        addCurrentPersonToQueue() {
            if (!this.isCatalogAgentRequest()) return;
            if (this.editingQueuePersonId) return;

            if (!this.isCatalogManualMode() && (!this.personSearchDone || !this.searchedPin)) {
                Utils.Alert(this.$t("catalogPinSearchRequired"));
                return;
            }

            this.$refs.ruleFormRef.validate((valid) => {
                if (!valid) return;
                if (!isQueuedPersonValid(this.values)) {
                    Utils.Alert(this.$t("catalogInsuredQueueInvalid"));
                    return;
                }

                const pin = normalizePin(this.searchedPin || this.values.pin);
                const payload = { ...this.values, pin };
                const wasFirstInQueue = this.pinQueue.length === 0;
                const { queue, entry } = upsertQueuedPerson(
                    this.pinQueue,
                    payload,
                    this.searchedPin || pin,
                    this.resolveCurrentPersonIsAsan()
                );
                this.pinQueue = queue;

                if (wasFirstInQueue && entry?.id) {
                    this.setMainFromQueue(entry.id);
                    this.includeMainInInsuredList = true;
                }

                this.resetEntryForm();
            });
        },
        resetEntryForm() {
            this.editingQueuePersonId = null;
            this.editingQueueIsAsan = false;
            const townId = this.values.townId ?? this.towns[0]?.townId ?? null;
            this.values = emptyEntryFormValues(townId);
            this.searchedPin = null;
            this.personSearchDone = false;
            this.$emit("reset-search-draft");
            this.$nextTick(() => this.$refs.ruleFormRef?.clearValidate?.());
        },
        removeInsuredRow(person) {
            if (!person?.id || person.isVirtual) return;
            if (person.id === this.editingQueuePersonId) {
                this.cancelQueuePersonEdit();
            }
            this.pinQueue = removeQueuedPerson(this.pinQueue, person.id);
            this.mainInsuredId = resolveMainInsuredIdAfterRemove(
                this.pinQueue,
                person.id,
                this.mainInsuredId
            );
            if (this.mainInsuredSource === "queue" && !this.mainInsuredId) {
                this.mainInsuredSource = "form";
            } else if (
                this.mainInsuredSource === "queue" &&
                this.mainInsuredId === person.id &&
                this.pinQueue.length > 0
            ) {
                this.setMainFromQueue(this.pinQueue[0].id);
            }
        },
        buildCatalogCardsList() {
            if (this.mainInsuredSource === "queue" && this.mainInsuredId) {
                const main = this.pinQueue.find((person) => person.id === this.mainInsuredId) || null;
                if (!main) return { main: null, cards: [] };

                const cards = this.includeMainInInsuredList
                    ? [...this.pinQueue]
                    : this.pinQueue.filter((person) => person.id !== this.mainInsuredId);
                return { main, cards };
            }

            const main = this.mainInsuredSnapshot;
            if (!main) return { main: null, cards: [] };

            let cards = [...this.pinQueue];
            if (this.includeMainInInsuredList) {
                const mainPin = normalizePin(main.values?.pin);
                if (mainPin && findQueuedPersonIndex(cards, mainPin) < 0) {
                    cards = [
                        createQueuedPerson(main.values, main.searchedPin, main.isAsan === true),
                        ...cards,
                    ];
                }
            }
            return { main, cards };
        },
        markPersonSearchSuccess(pinUsed) {
            const pin = normalizePin(pinUsed);
            if (!pin) return false;
            this.searchedPin = pin;
            this.personSearchDone = true;
            return true;
        },
        applyPersonSearchResult(mapped, pinForSearch) {
            const docSeries = this.isCatalogAgentRequest()
                ? this.activeSearchDraft.docSeries
                : this.values.docSeries;
            const docNumber = this.isCatalogAgentRequest()
                ? this.activeSearchDraft.docNumber
                : this.values.docNumber;
            const fullValues = {
                ...this.values,
                pin: pinForSearch,
                docSeries: mapped.docSeries ?? docSeries ?? "",
                docNumber: mapped.docNumber ?? docNumber ?? "",
                ...mapped,
            };
            this.values = fullValues;

            if (!this.isCatalogAgentRequest()) return;

            this.markPersonSearchSuccess(pinForSearch);
            this.syncMainInsuredSnapshot();
        },
        searchPersonByPin() {
            if (this.isCatalogManualMode()) return;

            const pinSource = this.isCatalogAgentRequest() ? this.activeSearchDraft.pin : this.values.pin;
            const seriesSource = this.isCatalogAgentRequest()
                ? this.activeSearchDraft.docSeries
                : this.values.docSeries;
            const numberSource = this.isCatalogAgentRequest()
                ? this.activeSearchDraft.docNumber
                : this.values.docNumber;
            const check = validatePersonInfoSearchInput(pinSource, seriesSource, numberSource);
            if (!check.ok) {
                Utils.Alert(this.$t("catalogPinRequired"));
                return;
            }

            const pinForSearch = normalizePin(check.pin);
            this.formPersonSearchLoading = true;
            this.personSearchDone = false;
            this.searchedPin = null;

            const payload = buildPersonInfoRequest(pinForSearch, {
                idSeries: check.idSeries,
                idNumber: check.idNumber,
            });
            const usedTestIdDoc = Boolean(payload._usedTestIdDoc);
            delete payload._usedTestIdDoc;

            MedicalAgent.GetPersonInfo(payload)
                .then((response) => {
                    const row = extractPersonInfoRow(response);
                    if (!isPersonInfoFound(row)) {
                        const apiErr =
                            extractPersonInfoErrorMessage(response) ||
                            Utils.formatApiErrors(response?.data?.errors);
                        Utils.Alert(apiErr || this.$t("catalogPersonNotFound"));
                        return;
                    }

                    const mapped = omitTestIdDocFromMapped(
                        mapPersonInfoToForm(row),
                        usedTestIdDoc
                    );
                    this.applyPersonSearchResult(mapped, pinForSearch);
                })
                .catch((error) => {
                    console.error("[Catalog] GetPersonInfo error:", error?.response?.data ?? error);
                    const msg = Utils.FormatErrorWithCorrelationId(error);
                    if (msg) Utils.Alert(msg);
                })
                .finally(() => {
                    this.formPersonSearchLoading = false;
                });
        },
        HandleCancel() {
            if (this.editing || this.noRedirect) {
                this.$emit('close-dialog');
            } else {
                this.$router.push('/cancel');
            }
        },
        LoadTowns() {
            const data = { requestCorrelationId: crypto.randomUUID() };
            Core.Town(data).then((response) => {
                if (response?.data?.isSuccess === true) {
                    this.towns = response.data.data || [];
                    if (this.towns.length > 0 && (this.values.townId == null)) {
                        this.values.townId = this.towns[0].townId;
                    }
                }
            }).catch((error) => {
                console.error('Error loading towns:', error);
            });
        },
        isCatalogAgentRequest() {
            return (
                this.insert &&
                this.noRedirect &&
                this.catalogProductId != null &&
                this.catalogProductId !== ""
            );
        },
        isCatalogManualMode() {
            return (
                this.isCatalogAgentRequest() &&
                this.activeSearchDraft.searchMode === CATALOG_PERSON_SEARCH_MODE.MANUAL
            );
        },
        SubmitForm() {
            if (this.submitting) return;
            if (this.isCatalogAgentRequest()) {
                if (this.isCatalogManualMode()) {
                    this.syncMainInsuredSnapshot();
                }
                if (!this.canSubmitCatalog) {
                    Utils.Alert(this.$t("catalogMainInsuredRequired"));
                    return;
                }
                const { main, cards } = this.buildCatalogCardsList();
                if (!main || !isQueuedPersonValid(main.values)) {
                    Utils.Alert(this.$t("catalogInsuredQueueInvalid"));
                    return;
                }
                const invalid = cards.find((p) => !isQueuedPersonValid(p.values));
                if (invalid) {
                    Utils.Alert(this.$t("catalogInsuredQueueInvalid"));
                    return;
                }
                this.submitCatalogAgentRequest(main, cards);
                return;
            }

            this.$refs.ruleFormRef.validate((valid) => {
                if (!valid) return;

                const { dateOfBirth, clientId, ...restValues } = this.values;
                const data = {
                    requestCorrelationId: crypto.randomUUID(),
                    data: {
                        clientId: this.editing ? clientId : 0,
                        ...restValues,
                        dateOfBirth: Utils.DateFormat(dateOfBirth),
                    },
                };

                if (this.editing) {
                    Source.EditClientRequest(data)
                        .then((response) => {
                            if (response?.data?.isSuccess === true) {
                                this.$emit("insert-dialog");
                            }
                        })
                        .catch((error) => {
                            console.error("Error editing insured:", error);
                        });
                } else {
                    Source.NewClientRequest(data).then((response) => {
                        if (this.noRedirect) {
                            this.$emit("insert-dialog", response.data.id);
                            this.$emit("close-dialog");
                        } else {
                            this.$router.push("/core/insureds/persons/" + response.data.id);
                        }
                    });
                }
            });
        },
        async submitCatalogAgentRequest(mainPerson, cardPersons) {
            if (this.submitting) return;
            if (!mainPerson?.values) {
                Utils.Alert(this.$t("catalogMainInsuredRequired"));
                return;
            }

            this.submitting = true;
            try {
                const payload = buildAgentRequestInsertPayload(
                    this.catalogProductId,
                    cardPersons || [],
                    mainPerson.values,
                    {
                        product: this.catalogProduct,
                        mainSearchedPin: mainPerson.searchedPin || normalizePin(mainPerson.values?.pin),
                        mainIsAsan: mainPerson.isAsan === true,
                    }
                );
                const response = await MedicalAgent.AgentRequestInsert(payload);
                const inserted = parseAgentRequestInsertResult(response);
                if (!inserted?.reqId) {
                    Utils.Alert(this.$t("error"));
                    return;
                }
                this.$emit("insert-dialog", inserted.reqId);
                this.$emit("close-dialog");
            } catch (error) {
                console.error("[Catalog] AgentRequestInsert:", error?.response?.data ?? error);
                const validationKey =
                    error?.message && String(error.message).startsWith("catalog")
                        ? error.message
                        : "";
                const msg =
                    (validationKey && this.$t(validationKey)) ||
                    Utils.formatApiErrors(error?.response?.data?.errors) ||
                    Utils.FormatErrorWithCorrelationId(error);
                if (msg) Utils.Alert(msg);
            } finally {
                this.submitting = false;
            }
        },
    }
}
</script>

